import { useBackend } from "../../services";

export const useCreateChatNotifications = () => {
  const { post } = useBackend();
  return async () => post("admin/createChatNotifications", {});
};
